import { render } from "./PayoutGuessLivePage.vue?vue&type=template&id=7a4aedfc"
import script from "./PayoutGuessLivePage.vue?vue&type=script&lang=js"
export * from "./PayoutGuessLivePage.vue?vue&type=script&lang=js"

import "./PayoutGuessLivePage.vue?vue&type=style&index=0&id=7a4aedfc&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__